import styled from "@emotion/styled";
import { Box } from "@mui/system";
import { RESPONSIVE_DRAWER } from "../../common/Common.style";

export const TemplateTabsContainer = styled(Box)`
  width: 70%;
  @media (max-width: ${RESPONSIVE_DRAWER.WIDE_BP - 1}px) {
    width: 90%;
  }
`;
